import React from 'react';
import { IGetPartners } from '../interfaces';

function GetPartners(props: IGetPartners) {
  let array: any = [];

  array = props.partnerFilter.map((partner: any) => {
    return (
      <option key={partner.id} value={partner.id}>
        {partner.id} - {partner.razao_social}
      </option>
    );
  });

  array.sort((a: any, b: any) => {
    if (a.props.value > b.props.value) {
      return 1;
    }
    if (a.props.value < b.props.value) {
      return -1;
    }
    return 0;
  });

  return array;
}

export default GetPartners;
